module.exports = __webpack_public_path__ + "img/right-4.35eb6ed5.png";